import "./styles.css";
import { AppController } from "./app/controller";

const fluidCanvas = requireElement("fluid-canvas", HTMLCanvasElement);
const textCanvas = requireElement("text-canvas", HTMLCanvasElement);
const wordInput = requireElement("word-input", HTMLInputElement);
const windToggle = requireElement("wind-toggle", HTMLButtonElement);
const status = requireElement("status", HTMLDivElement);

void AppController.create({
  fluidCanvas,
  textCanvas,
  wordInput,
  windToggle,
  status,
}).catch((error: unknown) => {
  status.textContent =
    error instanceof Error ? error.message : "The artwork could not start.";
  status.classList.add("is-error");
  status.classList.remove("is-hidden");
});

function requireElement<T extends Element>(
  id: string,
  constructor: { new (): T },
): T {
  const element = document.getElementById(id);
  if (!(element instanceof constructor)) {
    throw new Error(`Required element #${id} was not found.`);
  }
  return element;
}
